"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  PRP: 'PROMOTIONAL_RATE_PLAN',
  IL: 'INSTALLMENT_LOAN',
  IF: 'INTEREST_FREE_LOAN',
  LCFRP: 'LC_FIXED_RATE_PLAN',
  LCTNI: 'LC_TRUE_NO_INTEREST'
};
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');